module.exports = __webpack_public_path__ + "static/media/stofferingen-38.11043aa4.jpg";